// eslint-disable-next-line import/no-anonymous-default-export
export default {
  SUCCESS: {
    ok: 200,
    no_content: 204,
    duplication: 209,
  },
  ERROR: {
    bad_request: 400,
    not_acceptable: 406,
    conflict: 409,
  },
};
